/*  We use this function when BE start retuning date in ISO format strings
*  for now it's just a placeholder */
const isoStrToLocalStr = (str: string) => {
    return str
}

export default isoStrToLocalStr
